/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

import { MessageCenter } from 'utils';
import { limitsHandler } from '../../limits/index';

function handleInitialAdjustments({ questionnaire }) {
  return questionnaire.map(question => {
    return question;
  })
}

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
  token,
  globalQuestionnaire,
  updateIsLoadingStatus }) { }


async function handleRequestSerproCnpj({
  question: rootQuestion,
  data,
  operation,
  questionnaire,
  setQuestionnaire,
  setFieldValue,
  globalQuestionnaire,
  useGetShareCapitalInfoByLegalPersonIdRequest,
  limits,
  setLimits,
  shareCapital,
  modalitiesFeesData,
  scoreInformationData,
  modalities,
  setModalities,
  setQuestionnaireAnswersToDelete,
  questionnaireAnswersToDelete,
  useGetBorrowersInformationByLegalPersonIdsRequest,
}) {
  try {
    const mc = new MessageCenter();

    if (rootQuestion.idQuestion === 1825) {

      rootQuestion.answer = data.ni || "";

      setFieldValue(rootQuestion.key, rootQuestion.answer)
      
      const isProjectQuestion = globalQuestionnaire.find(qst => qst.idQuestion === 1723);
      const consumedLimitGroup = limits[limits.length - 1].find(qst => qst.idQuestion === 1832);
      let borrowerIsProject = false;
      
      if (rootQuestion.answer) {
        const { data: { value: personRoles } } = await useGetShareCapitalInfoByLegalPersonIdRequest(null, { legalPersonId: data.ni })

        const filteredOperation = personRoles?.filter(role => role.idOperation != operation.idOperation);

        if (isProjectQuestion?.idAnswerOption === 7336) {
          const { data: {value: [borrowerInfo]} } = await useGetBorrowersInformationByLegalPersonIdsRequest(
            null,
            { legalPersonIds: [data.ni] }
          );
  
          borrowerIsProject = borrowerInfo?.borrowerInfo?.isProject;
  
          if (borrowerIsProject) {
            mc.error(`O sócio ${data.ni} informado na composição social é uma SPE e não pode ser vinculado.`);
          }
        }

        questionnaire = questionnaire.map(qst => {
          if (borrowerIsProject) {
            qst.answer = '';
            qst.idAnswerOption = '';
            setFieldValue && setFieldValue(qst.key, '');
            if (qst.idQuestion === 1825) {
              qst.behaviorObject.extraExclamationWarning = false;
            }
          } else if (qst.idQuestion === 1825) {
            return qst = {
              ...qst,
              behaviorObject: {
                ...qst.behaviorObject,
                extraExclamationWarning: !!filteredOperation?.length,
              }
            }
          }
          return qst
        })
      }

      setQuestionnaire(questionnaire);

      if (
        isProjectQuestion?.idAnswerOption === 7336 && 
        consumedLimitGroup?.idAnswerOption === 7419 &&
        !borrowerIsProject
      ) {
        limitsHandler.events.handleSPELimit({
          globalQuestionnaire,
          limits,
          setLimits,
          shareCapital,
          setFieldValue,
          modalitiesFeesData,
          scoreInformationData,
          modalities,
          setModalities,
          setQuestionnaireAnswersToDelete,
          questionnaireAnswersToDelete,
          useGetBorrowersInformationByLegalPersonIdsRequest,
          mc,
        });
      }

      return;
    }

  } catch (e) {
    console.log('SHARE_CAPITAL - handleRequestSerproCnpj - error', e)
  }
};

function handleQuestionBlur({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
  modalities,
  setModalities,
  modalitiesFeesData,
  limits,
  setLimits,
  shareCapital,
  scoreInformationData,
  globalQuestionnaire,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
  useGetBorrowersInformationByLegalPersonIdsRequest,
}) {
  try {
    const mc = new MessageCenter();

    let saveFilteredQuestionnaire = false;

    if (question.idQuestion === 1828) {
      const isProjectQuestion = globalQuestionnaire.find(qst => qst.idQuestion === 1723);
      const consumedLimitGroup = limits[limits.length - 1].find(qst => qst.idQuestion === 1832);

      if (isProjectQuestion?.idAnswerOption === 7336 && consumedLimitGroup?.idAnswerOption === 7419) {
        limitsHandler.events.handleSPELimit({
          globalQuestionnaire,
          limits,
          setLimits,
          shareCapital,
          setFieldValue,
          modalitiesFeesData,
          scoreInformationData,
          modalities,
          setModalities,
          setQuestionnaireAnswersToDelete,
          questionnaireAnswersToDelete,
          useGetBorrowersInformationByLegalPersonIdsRequest,
          mc,
        });
      }
    }

    if (saveFilteredQuestionnaire) setQuestionnaire(questionnaireUpdated);
  } catch (e) {
    console.log("LIMITS - handleQuestionBlur error", e)
  }
}

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleRequestSerproCnpj,
  handleQuestionBlur,
}

export { events };
